import React from "react";

const macroAreas = [
  {
    id: "lavoro",
    n: "01",
    label: "Diritto del Lavoro",
    title: "La tutela del rapporto di lavoro, in ogni sua fase.",
    desc: "Consulenza, vertenze e contenzioso a fianco di lavoratori, dirigenti e imprese.",
    items: [
      "Licenziamenti e impugnazioni",
      "Contratti di lavoro e patti accessori",
      "Mobbing e demansionamento",
      "Vertenze e conciliazioni",
      "Contenzioso INPS / INAIL",
      "Dirigenti, quadri e top management",
    ],
  },
  {
    id: "civile",
    n: "02",
    label: "Diritto Civile",
    title: "Locazioni, contratti e recupero crediti.",
    desc: "Assistenza completa in materia contrattuale e patrimoniale, in via stragiudiziale e giudiziale.",
    items: [
      "Locazioni abitative e commerciali",
      "Sfratti per morosità e finita locazione",
      "Redazione e revisione contratti",
      "Recupero crediti — decreti ingiuntivi",
      "Esecuzioni mobiliari e immobiliari",
      "Responsabilità civile e risarcimento danni",
    ],
  },
  {
    id: "penale",
    n: "03",
    label: "Diritto Penale",
    title: "Difesa tecnica e tutela della persona offesa.",
    desc: "Assistenza nelle indagini preliminari, nel dibattimento e nei riti alternativi.",
    items: [
      "Difesa dell'imputato in ogni grado di giudizio",
      "Assistenza alla persona offesa e costituzione di parte civile",
      "Reati contro la persona e il patrimonio",
      "Reati colposi e infortunistica stradale",
      "Reati in ambito lavorativo e d.lgs. 231",
      "Misure cautelari e riti alternativi",
    ],
  },
];

export default function Expertise() {
  return (
    <section id="materia" data-testid="expertise-section" className="relative py-24 md:py-32 bg-[#0F172A] text-[#FDFBF7]">
      <div className="container-ed">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14 md:mb-20">
          <div className="lg:col-span-7">
            <div className="overline mb-6" style={{ color: "#D4B77A" }}>
              Aree di competenza
            </div>
            <h2 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Tre materie, <span className="italic" style={{ color: "#D4B77A" }}>una sola dedizione</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-white/70">
              Lavoro, civile e penale: dalla fase consulenziale alla difesa in giudizio,
              lo Studio affianca ogni cliente con competenza settoriale e visione d'insieme.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 border-t border-white/10">
          {macroAreas.map((m, i) => (
            <div
              key={m.id}
              data-testid={`area-${m.id}`}
              className={`group p-8 md:p-10 lg:p-12 transition-colors duration-300 hover:bg-white/[0.03] border-b border-white/10 ${
                i !== macroAreas.length - 1 ? "lg:border-r lg:border-b-0" : ""
              }`}
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="serif text-xl" style={{ color: "#D4B77A" }}>
                  {m.n}
                </span>
                <span className="overline text-[10px] text-white/50">{m.label}</span>
              </div>
              <h3 className="serif text-2xl md:text-3xl leading-snug text-white">
                {m.title}
              </h3>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-white/70">
                {m.desc}
              </p>
              <ul className="mt-8 pt-6 border-t border-white/10 space-y-3">
                {m.items.map((it) => (
                  <li
                    key={it}
                    className="flex items-start gap-3 text-sm leading-relaxed text-white/85"
                  >
                    <span
                      className="mt-2 h-px w-3 shrink-0"
                      style={{ background: "#D4B77A" }}
                    />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
